import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { LogOut } from "lucide-react";
import { toast } from "sonner";
import { Seo } from "@/components/Seo";
import { Loader, Mascot } from "@/components/brand/Mascot";
import { AuthForms } from "@/components/account/AuthForms";
import { Activity, Orders, Points, Profile, Rewards } from "@/components/account/AccountPanels";
import { useAuth } from "@/context/AuthContext";

const TABS = [["profile", "Profile", Profile], ["orders", "Orders", Orders], ["points", "Crew Points", Points], ["rewards", "Rewards", Rewards], ["activity", "Gift cards & alerts", Activity]];

export default function Account() {
  const { user, signOut, refresh } = useAuth();
  const [params, setParams] = useSearchParams();
  const tab = params.get("tab") || "profile";
  const [shown, setShown] = useState(false);
  useEffect(() => {
    if (shown || !params.get("verified")) return;
    setShown(true);
    if (params.get("verified") === "1") { toast.success("Email verified. Guest orders are now linked."); if (user) refresh(); } else toast.error("That verification link expired.");
  }, [params, shown, user, refresh]);
  if (user === undefined) return <Loader label="Loading your account" />;
  const Panel = (TABS.find((t) => t[0] === tab) || TABS[0])[2];
  return (
    <div className="mx-auto max-w-[1440px] px-5 pb-28 pt-12 sm:px-10 lg:pt-20" data-testid="account-page">
      <Seo title="My account" description="Your account at the suspects: orders, Crew Points and rewards." path="/account" noindex />
      {!user ? (
        <><h1 className="display mb-12 text-[clamp(3.5rem,9vw,7.5rem)]">Join the <span className="hl hl-lime hl-thick">crew</span></h1><AuthForms /></>
      ) : (
        <>
          <header className="flex flex-wrap items-end justify-between gap-6">
            <div className="flex items-center gap-5"><Mascot size={64} label="" /><div><p className="label text-ink/55">My account</p><h1 className="display text-[clamp(3rem,7vw,6rem)]" data-testid="account-name">Hey {user.name || "suspect"}</h1></div></div>
            <div className="flex items-center gap-4"><span className="label rounded-full bg-lime px-4 py-2 font-bold" data-testid="account-points">{user.points} pts</span>
              <button onClick={signOut} className="link-u inline-flex items-center gap-2" data-testid="account-logout"><LogOut size={14} /> Log out</button></div>
          </header>
          <nav className="no-scrollbar -mx-1 mt-10 flex gap-2 overflow-x-auto px-1" aria-label="Account sections">
            {TABS.map(([id, l]) => <button key={id} onClick={() => setParams({ tab: id })} aria-pressed={tab === id} className={`label h-9 shrink-0 rounded-full border-[1.5px] border-ink px-5 font-bold ${tab === id ? "bg-ink text-cloud" : "hover:bg-ink/5"}`} data-testid={`account-tab-${id}`}>{l}</button>)}
          </nav>
          <div className="mt-8"><Panel /></div>
        </>
      )}
    </div>
  );
}
